export enum PdbEndpoint {
  AsphaltCutters = "api/products/asphaltcutters/productguide",
  Buckets = "api/products/buckets/productguide",
  Compactors = "api/products/compactors/productguide",
  GradingBeams = "api/products/gradingbeams/productguide",
  GrappleModules = "api/products/grapplemodules/productguide",
  Grapples = "api/products/grapples/productguide",
  LowerBrackets = "api/products/lowerbrackets/productguide",
  MachineFixings = "api/products/machinefixings/productguide",
  MachineSearch = "machinemodelswithmachinename",
  RailGrapples = "api/products/railgrapples/productguide",
  Rippers = "api/products/rippers/productguide",
  Tiltrotator = "api/products/rototilts/productguide",
  UpperBrackets = "api/products/upperbrackets/productguide",
}
